class RandomizeHelper {
  /**
   * This method will return a random uuid
   * @returns {string} uuid
   */
  static getUUID() {
    const arr = new Uint8Array(16);
    crypto.getRandomValues(arr);

    arr[6] = (arr[6] & 0x0f) | 0x40;
    arr[8] = (arr[8] & 0x3f) | 0x80;

    return [...arr]
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")
      .replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, "$1-$2-$3-$4-$5");
  }

  /**
   * This method will generate a random string of the given length using the characters A-Z, a-z, 0-9, and -._~
   * @param {int} length The length of the random string to generate
   * @returns {string} The generated random string
   */
  static generateRandomString(length) {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let result = "";
    const values = crypto.getRandomValues(new Uint8Array(length));
    values.forEach((v) => (result += charset[v % charset.length]));
    return result;
  }

  /**
   * This method will encode an ArrayBuffer to a base64url string
   * @param {ArrayBuffer} arrayBuffer The ArrayBuffer to encode
   * @returns {string} The base64url-encoded string
   */
  static base64UrlEncode(arrayBuffer) {
    const bytes = new Uint8Array(arrayBuffer);
    let binary = "";

    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window
      .btoa(binary)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  /**
   * This method will generate a PKCE verifier and challenge
   * The verifier is a random string and the challenge is a base64url-encoded SHA256 hash of the verifier
   * @returns {Promise<object>} An object containing the verifier and challenge
   */
  static async generatePKCE() {
    const verifier = RandomizeHelper.generateRandomString(128);

    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await crypto.subtle.digest("SHA-256", data);

    const challenge = this.base64UrlEncode(digest);

    return { verifier, challenge };
  }
}

export default RandomizeHelper;
